/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayoutRecord
 */
export interface PayoutRecord {
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    creditor: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    currency: string;
    /**
     * 
     * @type {Date}
     * @memberof PayoutRecord
     */
    fromDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PayoutRecord
     */
    toDate: Date;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    commissionAmount?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PayoutRecord
     */
    estimatedPayoutDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    feeAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    grossAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    netAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    paidOutAmount?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PayoutRecord
     */
    payoutInitiatedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PayoutRecord
     */
    toAccount?: string | null;
}

/**
 * Check if a given object implements the PayoutRecord interface.
 */
export function instanceOfPayoutRecord(value: object): value is PayoutRecord {
    if (!('creditor' in value) || value['creditor'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PayoutRecordFromJSON(json: any): PayoutRecord {
    return PayoutRecordFromJSONTyped(json, false);
}

export function PayoutRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayoutRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'creditor': json['creditor'],
        'currency': json['currency'],
        'fromDate': (new Date(json['fromDate'])),
        'toDate': (new Date(json['toDate'])),
        'type': json['type'],
        'commissionAmount': json['commissionAmount'] === undefined ? undefined : json['commissionAmount'] === null ? null : json['commissionAmount'],
        'estimatedPayoutDate': json['estimatedPayoutDate'] === undefined ? undefined : json['estimatedPayoutDate'] === null ? null : (new Date(json['estimatedPayoutDate'])),
        'feeAmount': json['feeAmount'] === undefined ? undefined : json['feeAmount'] === null ? null : json['feeAmount'],
        'grossAmount': json['grossAmount'] === undefined ? undefined : json['grossAmount'] === null ? null : json['grossAmount'],
        'netAmount': json['netAmount'] === undefined ? undefined : json['netAmount'] === null ? null : json['netAmount'],
        'paidOutAmount': json['paidOutAmount'] === undefined ? undefined : json['paidOutAmount'] === null ? null : json['paidOutAmount'],
        'payoutInitiatedDate': json['payoutInitiatedDate'] === undefined ? undefined : json['payoutInitiatedDate'] === null ? null : (new Date(json['payoutInitiatedDate'])),
        'toAccount': json['toAccount'] === undefined ? undefined : json['toAccount'] === null ? null : json['toAccount'],
    };
}

export function PayoutRecordToJSON(json: any): PayoutRecord {
    return PayoutRecordToJSONTyped(json, false);
}

export function PayoutRecordToJSONTyped(value?: PayoutRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creditor': value['creditor'],
        'currency': value['currency'],
        'fromDate': value['fromDate'].toISOString(),
        'toDate': value['toDate'].toISOString(),
        'type': value['type'],
        'commissionAmount': value['commissionAmount'],
        'estimatedPayoutDate': value['estimatedPayoutDate'] == null ? value['estimatedPayoutDate'] : value['estimatedPayoutDate'].toISOString().substring(0,10),
        'feeAmount': value['feeAmount'],
        'grossAmount': value['grossAmount'],
        'netAmount': value['netAmount'],
        'paidOutAmount': value['paidOutAmount'],
        'payoutInitiatedDate': value['payoutInitiatedDate'] == null ? value['payoutInitiatedDate'] : value['payoutInitiatedDate'].toISOString().substring(0,10),
        'toAccount': value['toAccount'],
    };
}

